import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';

interface RatingsSectionProps {
  /** Null when nothing is rated: `AVG` over zero rows is NULL, and 0 would read as a bad score. */
  avg: number | null;
  count: number;
}

/**
 * Read-only, always: a rating is given by the ticket reporter (#294), never edited from here.
 * It is opt-in on one service desk, so an empty section is the normal case rather than a fault.
 */
const RatingsSection = ({ avg, count }: RatingsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Star className="h-4 w-4" aria-hidden="true" />
          {t('Ratings')}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex items-baseline gap-3">
        <span className="text-2xl font-semibold tabular-nums text-zinc-900 dark:text-zinc-50">
          {avg === null ? '—' : avg.toFixed(1)}
        </span>
        <span className="text-sm text-zinc-500 dark:text-zinc-400">
          {count === 0
            ? t('No rating yet')
            : t('{{count}} rating', { count })}
        </span>
      </CardContent>
    </Card>
  );
};

export default RatingsSection;
